import { render, staticRenderFns } from "./submit.vue?vue&type=template&id=22c6ee38&scoped=true&"
import script from "./submit.vue?vue&type=script&lang=js&"
export * from "./submit.vue?vue&type=script&lang=js&"
import style0 from "./submit.vue?vue&type=style&index=0&id=22c6ee38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c6ee38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22c6ee38')) {
      api.createRecord('22c6ee38', component.options)
    } else {
      api.reload('22c6ee38', component.options)
    }
    module.hot.accept("./submit.vue?vue&type=template&id=22c6ee38&scoped=true&", function () {
      api.rerender('22c6ee38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/form/setting/submit.vue"
export default component.exports